/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';
import { GridRowContainer } from '@veeam/components';

import type React from 'react';

export interface CustomGridRowContainerProps {
    isLast?: boolean;
}

export const CustomGridRowContainer = styled(GridRowContainer)<React.ComponentProps<typeof GridRowContainer> & CustomGridRowContainerProps>`
    cursor: pointer;
    border-bottom: ${({ theme, isLast }) => isLast ? 'none' : `1px solid ${theme.colorBorderGrid}`};
`;
